<!-- Color pill that uses a regular border radius -->
<template>
  <div class="gmf-color-pill-radius">
    <ColorPillBase :colors="colors" />
  </div>
</template>
<style>
.gmf-color-pill-radius {
  border-radius: 50%;
  width: 38px;
  height: 38px;
  overflow: hidden;
}
</style>
<script>
import ColorPillBase from './ColorPillBase.vue';

export default {
  components: {
    ColorPillBase,
  },
  props: {
    colors: {
      Type: [Array, Object, String], // Set ColorPillBase for usage.
    },
  },
};
</script>